
const SocialMediaSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold text-drcash-maastricht-blue mb-8">
          Redes Sociais
        </h2>
        <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
          Siga-nos nas redes sociais para ficar por dentro das novidades, dicas e atualizações da Dr.Cash
        </p>
        <div className="flex justify-center gap-6">
          <a
            href="https://www.linkedin.com/company/drcashbr"
            target="_blank"
            rel="noopener noreferrer"
            className="text-drcash-maastricht-blue hover:text-drcash-caribbean-green transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
              <rect x="2" y="9" width="4" height="12"></rect>
              <circle cx="4" cy="4" r="2"></circle>
            </svg>
          </a>
          <a
            href="https://www.instagram.com/drcashbr"
            target="_blank"
            rel="noopener noreferrer"
            className="text-drcash-maastricht-blue hover:text-drcash-caribbean-green transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
          </a>
          <a
            href="https://www.facebook.com/drcash.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="text-drcash-maastricht-blue hover:text-drcash-caribbean-green transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaSection;
